import { Entity } from '@data-client/rest';
import { ISODate } from '../utils/transforms';
class OrganizationTypeEntity extends Entity {
    constructor() {
        super(...arguments);
        this.creationDTTM = null;
        this.id = 0;
        this.title = '';
        this.updatedByUserId = null;
        this.updatedDTTM = null;
    }
    pk() {
        return this.id.toString();
    }
}
OrganizationTypeEntity.schema = {
    creationDTTM: ISODate,
    updatedDTTM: ISODate
};
OrganizationTypeEntity.key = 'OrganizationType';
export { OrganizationTypeEntity };
